<template>
  <div
    :class="[
      'card-container',
      mode === 'HORIZONTAL'
        ? 'card-container_horizontal'
        : 'card-container_vertical'
    ]"
  >
    <slot name="image">
      <div class="image">
        <img :src="adCardInfo._imgSrc" class="img_ad" />
      </div>
    </slot>
    <slot name="desc">
      <div class="desc">
        <div class="sub-title r-ellipsis-l2">{{ adCardInfo._subTitle }}</div>
        <div class="intro">
          <template v-if="adCardInfo._date">
            <div class="date">{{ adCardInfo._date }}</div>
          </template>
          <template v-if="adCardInfo._clickNum">
            <div class="num">{{ adCardInfo._clickNum }}观看</div>
          </template>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { DISPLAY } from "../shared";

export default {
  name: "SkeletonCard",

  props: {
    adCardInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    mode: {
      type: String,
      default() {
        return DISPLAY.VERTICAL;
      }
    }
  },

  components: {}
};
</script>

<style lang="scss" scoped>
.card-container {
  font-size: 12px;
  .image {
    width: 240px;
    height: 100px;
    .img_ad {
      width: 240px;
      height: 100px;
      border-radius: 6px;
    }
  }
  .desc {
    margin-top: 5px;
    width: 240px;
    .sub-title {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  .intro {
    display: flex;
    .num {
      margin-left: 5px;
    }
  }
}
.card-container_vertical {
  .desc {
    .sub-title {
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .intro {
      color: #999;
    }
  }
}
.card-container_horizontal {
  display: flex;
  font-size: 12px;
  .image {
    width: 100px;
    height: 60px;
    .img_ad {
      width: 100px;
      height: 60px;
      border-radius: 6px;
    }
  }
  .desc {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    margin-left: 10px;
    .sub-title {
      margin-top: 0px;
      margin-bottom: 0px;
      height: 25px;
      overflow: hidden;
    }
    .intro {
      margin-top: auto;
      color: #999;
      .date {
        word-break: keep-all;
        white-space: nowrap;
        max-width: 80px;
        overflow: hidden;
      }
    }
  }
}

.r-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.r-ellipsis-l2 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
